let currentVarChange;
let globalTabGallery; // Global Swiper instance

let currentUrl = window.location.href;

// Button group functionality removed - handled by new gallery implementation

const logObserver = new MutationObserver(() => {
  if (currentUrl !== window.location.href) {
    currentUrl = window.location.href;
    handleUrlChange();
  }
});

logObserver.observe(document, { subtree: true, childList: true });

function handleUrlChange() {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    handleVariantChange(variantId);
  }
}

// Thumbnail scrolling functionality removed - handled by new gallery implementation

function sortImages(array, ids) {
  return array.find((variantObj) => variantObj.id == ids);
}

function handleVariantChange(variantId) {
  // Update the current variant change variable
  currentVarChange = variantId;
  
  // Dispatch a custom event for the new gallery system to handle
  document.dispatchEvent(new CustomEvent('variantChange', {
    detail: {
      variant: {
        id: variantId
      }
    }
  }));
}

// Call the function once on load to handle the initial state
handleUrlChange();

window.addEventListener(
  "load",
  function (event) {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    currentVarChange = variantId;
    
    // Mobile gallery is now handled by the new gallery implementation
  },
  false
);

$(document).ready(function () {
  var iframeAssemblyMobile = document.querySelector("#vimeoPlayerAssemblyMobile");
  if (iframeAssemblyMobile) {
    var playerPdp_assemblyMobile = new Vimeo.Player(iframeAssemblyMobile);
    playerPdp_assemblyMobile.on('error', function(error) {
      console.warn(error);
      if (error.name === "TypeError" || error.name === "PasswordError" || error.name === "PrivacyError") {
        document.getElementById('step2video_assemblyMobile').style.display = 'none';
      }
    });

    $("#step2video_assemblyMobile").click(function () {
      playerPdp_assemblyMobile.play();
      $("#step2video_assemblyMobile").addClass("remove_facade");
      setTimeout(function () {
        $("#step2video_assemblyMobile").css("display", "none");
      }, 600);
    });
  } else {
    console.warn("Couldn't find mobile iframe for assembly video");
  }

  var iframeAssemblyDesktop = document.querySelector("#vimeoPlayerAssemblyDesktop");
  if (iframeAssemblyDesktop) {
    var playerPdp_assemblyDesktop = new Vimeo.Player(iframeAssemblyDesktop);
    playerPdp_assemblyDesktop.on('error', function(error) {
      console.warn(error);
      if (error.name === "TypeError" || error.name === "PasswordError" || error.name === "PrivacyError") {
        document.getElementById('step2video_assemblyDesktop').style.display = 'none';
      }
    });

    $("#step2video_assemblyDesktop").click(function () {
      playerPdp_assemblyDesktop.play();
      $("#step2video_assemblyDesktop").addClass("remove_facade");
      setTimeout(function () {
        $("#step2video_assemblyDesktop").css("display", "none");
      }, 600);
    });
  } else {
    console.warn("Couldn't find desktop iframe for assembly video");
  }
});

// Check if the .product-form__input element exists
const fieldset = document.querySelector(".js.product-form__input");
if (fieldset) {
  // Get all the radio input elements within the fieldset
  const radioInputs = fieldset.querySelectorAll('input[type="radio"]');

  // Function to update the .js-va-option span with the selected value
  function updateSelectedValue() {
    // Find the selected radio input
    const selectedRadio = fieldset.querySelector('input[type="radio"]:checked');

    if (selectedRadio) {
      // Get the value of the selected radio input
      const selectedValue = selectedRadio.value;

      // Find the .js-va-option span within the legend and update its text content
      const vaOptionSpan = fieldset.querySelector(".js-va-option");
      vaOptionSpan.textContent = selectedValue;
    }
  }

  // Add a change event listener to the radio inputs
  radioInputs.forEach((radioInput) => {
    radioInput.addEventListener("change", updateSelectedValue);
  });

  // Set the initial value when the page loads
  updateSelectedValue();
}

// Gallery navigation functionality removed - handled by new gallery implementation

// Intersection Observer functionality removed - handled by new gallery implementation

document.addEventListener("DOMContentLoaded", function () {
  const accordionTitles = document.querySelectorAll(
    ".PdpHero-content_accordion_title"
  );
  const detailsWrapper = document.querySelector(
    ".pdp-hero-wrapper-content-details"
  );

  accordionTitles.forEach(function (title) {
    title.addEventListener("click", function () {
      const accordion = this.closest(".PdpHero-content_accordion");
      if (accordion) {
        accordion.classList.toggle("PdpHero-content_accordion--active");

        // Check if any accordion is active
        const anyAccordionActive = [...accordionTitles].some((title) => {
          const accordion = title.closest(".PdpHero-content_accordion");
          return (
            accordion &&
            accordion.classList.contains("PdpHero-content_accordion--active")
          );
        });

        // Add or remove the class accordingly
        if (anyAccordionActive) {
          detailsWrapper.classList.add("PdpHero-right-relative");
        } else {
          detailsWrapper.classList.remove("PdpHero-right-relative");
        }
      }
    });
  });
});

const minusButton = document.querySelector(".quantity__button_minus");
const plusButton = document.querySelector(".quantity__button_plus");
const outOfStockMessage = document.querySelector(".out_of_stock_message");
const productSubmit = document.querySelector(".product-form__submit");

plusButton.addEventListener("click", function () {
  if (plusButton.classList.contains("disabled")) {
    outOfStockMessage.classList.add("show_qty_message");
    productSubmit.classList.add("disabled_atc");
  } else {
    outOfStockMessage.classList.remove("show_qty_message");
    productSubmit.classList.remove("disabled_atc");
  }
});

minusButton.addEventListener("click", function () {
  if (plusButton.classList.contains("disabled")) {
    outOfStockMessage.classList.add("show_qty_message");
    productSubmit.classList.add("disabled_atc");
  } else {
    outOfStockMessage.classList.remove("show_qty_message");
    productSubmit.classList.remove("disabled_atc");
  }
});

const quantityInput = document.querySelector(".quantity__input_main");

function updateButtonClass() {
  if (quantityInput.value > 1) {
    minusButton.classList.add("active_minus");
  } else {
    minusButton.classList.remove("active_minus");
  }
}

minusButton.addEventListener("click", () => {
  if (quantityInput.value > 1) {
    // Handle minus button click when value is greater than 1
  }
  updateButtonClass();
});

plusButton.addEventListener("click", () => {
  updateButtonClass();
});

updateButtonClass();
